<template>
    <Layout
        :header="{ text: titleText, backBtn: { visible: true }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_HOME } }, }">
        <div class="pt-2 pb-6">
            <Process :steps="['選擇保單', '填寫資料', '確認資料', '視訊預約',]" :index="0"></Process>
        </div>
        <h2 class="font-bold text-2xl pb-4">選擇保單</h2>
        <div class="pb-4">
            <OptionBox inputName="policy" inputType="radio" :inputOption="inputOption" :inputValue="selectedItem"
                :setInputValue="(policyNumber) => { selectedItem = policyNumber; }" v-for="inputOption in policyList">
            </OptionBox>
        </div>
        <h2 class="font-bold text-2xl pb-4">暫時無法變更的保單</h2>
        <p class="pb-4">以下保單因變更中、保單借款中、理賠申請中暫時無法申請</p>
        <CaseBox :caseBox="disabledItem" v-for="disabledItem in disabledPolicyList"></CaseBox>
        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="selectedItem == null" @click="goNextPage">下一步</button>
        </template>
        <InfoBox v-if="errorBoxVisble" :closeHandel="() => router.push({ name: routeName.CLOUD_E_COUNTER_HOME })"
            title="系統提示" buttonText="我知道了">
            <div v-html="errorMessage" />
        </InfoBox>
        <Loading :is-loading="isLoading" />
    </Layout>
</template>
<script setup>
import Layout from '@/components/cloudCounter/Layout.vue'
import Process from '@/components/cloudCounter/Process.vue'
import OptionBox from '@/components/cloudCounter/OptionBox.vue'
import CaseBox from '@/components/cloudCounter/CaseBox.vue'

import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Loading from '@/components/Loading.vue';
import { policyOverview, selectChangedPolicy, startTransaction, getContactInfo } from '@/apis/system';
import aplCatlCode from '@/json/aplCatlCode';
import { openPopup } from '@/utils/vfmUtils';
import routeName from '@/router/constant';
import InfoBox from '@/components/cloudCounter/InfoBox.vue'

const router = useRouter();
const store = useStore();

const aplCatl = computed(() => store.state.services.aplCatl);
const serviceList = computed(() => store.state.services.serviceList);

const isLoading = ref(false);
const titleText = ref('');
const data = ref([]);
const policyList = ref([]);
const selectedItem = ref(null);
const disabledPolicyList = ref([]);
const errorBoxVisble = ref(false);
const errorMessage = ref('');

const getData = () => {
    let type = '';
    if (aplCatl.value === aplCatlCode.BENEIFCIARY) {
        // 重置受益人變更
        store.dispatch('services/setChangeItemsResult', { code: aplCatlCode.BENEIFCIARY, value: null });        
        type = 'BENEFICIARY_CHANGE';
        titleText.value = '受益人變更'
    } else if (aplCatl.value === aplCatlCode.APPLICANT_CHANGE) {
        type = 'APPLICANT_CHANGE';
        titleText.value = '要保人變更'
    } else if (aplCatl.value === aplCatlCode.APPLICANT_INSURED_NAME_CHANGE) {
        type = 'APPLICANT_INSURED_NAME_CHANGE';
        titleText.value = '要保人或被保險人姓名變更'
    }
    isLoading.value = true
    policyOverview(type).then(res => {
        data.value = res.data?.policyList || [];
        disabledPolicyList.value = [];
        policyList.value = [];
        if (data.value.length > 0) {
            // 以memo是否有內容判斷是否為可異動的保單
            data.value.filter(e => e.memo.trim().length === 0).forEach(e => {
                policyList.value.push({
                    title: `${e.item} ${e.itemName}`,
                    subTitle: e.fullPolicyNo,
                    optionValue: e.fullPolicyNo,
                    list: [
                        { key: '被保險人姓名', value: e.name, },
                        { key: '契約狀況', value: e.cnctStatText, },
                        { key: '契約始期', value: e.effectDateTW, },
                    ]
                })
            });

            data.value.filter(e => e.memo.trim().length !== 0).forEach(e => {
                disabledPolicyList.value.push({
                    key: e.fullPolicyNo,
                    value: `${e.item} ${e.itemName}`,
                    iconTitle: e.memo
                })
            })
        }
    }).catch(err => {
        console.log(err);
    }).finally(() => {
        isLoading.value = false
    });
};
getData();

const toServicePage = (item) => {
    isLoading.value = true;
    const requestBody = {
        policyNo: item.policyNo,
        policySeq: item.policySeq,
        idDup: item.idDup,
        srceFrom: item.srceFrom,
    };
    selectChangedPolicy(requestBody).then(() => {
        store.dispatch('policy/setPolicy', item);
        const index = serviceList.value.findIndex(i => i.transactionItemNo === aplCatl.value);
        if (serviceList.value.length > index) {
            getContactInfo().then(res => {
                if (!res?.data?.mobile && res?.data?.id !== res?.data?.insuredId) {
                    errorBoxVisble.value = true;
                    errorMessage.value = '您的保單未留存行動電話無法使用雲端e櫃檯服務，如欲申請此功能，請先至保單變更，辦理要保人行動電話變更。';
                } else {
                    startTransaction().then(res => {
                        const nextService = serviceList.value[index];
                        router.push({ name: nextService.routeName });
                    }).catch(ex => {
                        openPopup(ex);
                    });
                }
            })
        }
    }).finally(() => {
        isLoading.value = false;
    });
};

const goNextPage = () => {
    let item = data.value.find(e => e.fullPolicyNo === selectedItem.value)
    toServicePage(item)
}

</script>
<style lang="scss" scoped></style>
